import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FormItem extends Component {
  render() {
    const {
      children,
      className,
      type,
      ...otherProps
    } = this.props;

    const attributes = {
      ...otherProps,
      className: classNames('form-item', type, className)
    };

    return (
      <div {...attributes}>
        {children}
      </div>
    );
  }
}

FormItem.propTypes = {
  type: PropTypes.string
};

FormItem.defaultProps = {
  type: 'text-item'
};

export default FormItem;



// WEBPACK FOOTER //
// ./src/containers/components/form-item.js